const getters = {
  userId: state => state.user.userId,
  nickname: state => state.user.name,
  isAdmin: state => state.user.isAdmin,
  userInfomation: state => state.user.info,
  roleCname: state => state.user.roleCname,
  permissionLevel: state => state.user.permissionLevel,
  sppucAccount: state => state.user.sppucAccount,
  isShowLeft: state => state.app.isShowLeft,
  isLeftDrawVisible: state => state.app.isLeftDrawVisible,
  isShowRight: state => state.app.isShowRight,
  isRightDrawVisible: state => state.app.isRightDrawVisible,
  isShowTop: state => state.app.isShowTop,
  maxZIndex: state => state.app.maxZIndex,
  isDrawState: state => state.app.isDrawState,
  uiHiddenState: state => state.app.uiHiddenState,
  folderTree: state => state.marker.folderTree,
  layerList: state => state.marker.layerList,
  markerDatas: state => state.marker.markerDatas,
  apiSourceDatas: state => state.marker.apiSourceDatas,
  selectedMarker: state => state.marker.selectedMarker,
  isInMarkerEditing: state => state.marker.isInMarkerEditing,
  layerVisibleStorage: state => state.marker.layerVisibleStorage,
  _layerId: state => state.app._layerId,
  curMapId: state => state.app.curMapId,
  isTemplate: state => state.app.isTemplate,
  modelHeight: state => state.marker.modelHeight,
  markerIcons: state => state.marker.markerIcons,
  layerTree: state => state.marker.layerTree,
  defaultViewPoint: state => state.viewer.defaultViewPoint,
  frequentViewPoint: state => state.viewer.frequentViewPoint,
  searchParams: state => state.poiSearch.searchParams,
  searchResult: state => state.poiSearch.searchResult,
  poi2Marker: state => state.poiSearch.poi2Marker,
  showSplitScreenContrast: state => state.marker.showSplitScreenContrast,
  viewShed3DData: state => state.marker.viewShed3DData,
  editMarkerData: state => state.marker.editMarkerData,
  removeMarkerId: state => state.marker.removeMarkerId,
  markerPositionEdit: state => state.marker.markerPositionEdit,
  showImportkml: state => state.marker.showImportkml,
  importkmlType: state => state.marker.importkmlType,
  isShowSpaceSearchDraw: state => state.marker.isShowSpaceSearchDraw,
  isShowSpaceTool: state => state.marker.isShowSpaceTool,
  spaceSearchData: state => state.marker.spaceSearchData,
  spaceSearchStatisticsData: state => state.marker.spaceSearchStatisticsData,
  spaceSearchJeojson: state => state.marker.spaceSearchJeojson,
  volumeMeasureMarker: state => state.marker.volumeMeasureMarker,
  mapInfo: state => state.marker.mapInfo,
  updateSppucDevice: state => state.sppuc.updateSppucDevice
}

export default getters
